<div class="header">
  <div class="right">
    <div class="arraow">
      <img class="scale-img" src="/assets/images/definitions/back.svg" (click)="goBack()">
    </div>
    <div class="info">
      <div class="que-info">
        <que-logo-display [isHeader]="true"></que-logo-display>
        <div class="que-name">
          <span translate>header.viewAnswers.questionnaireApproval</span>:
          {{ questionnaire$()?.definitions?.name }}
        </div>
      </div>
      <div class="sender-info">
        <span class="loggedUser">
          {{ currentAnswersUser$()?.firstName?.charAt(0)?.toUpperCase() }}{{
          currentAnswersUser$()?.lastName?.charAt(0)?.toUpperCase() }}
        </span>
        <div class="sender-details">
          <div class="sender-name">
            {{ 'header.viewAnswers.senderName' | translate }}:
            {{ currentAnswersUser$()?.firstName }} {{ currentAnswersUser$()?.lastName }}
          </div>

          <div class="dates-row" *ngIf="sentDate$() || approvalDate$()">
            <span class="sent-date" *ngIf="sentDate$()">
              {{ 'header.viewAnswers.sentDate' | translate }}: {{ sentDate$() | date:'dd/MM/yyyy' }}
            </span>
            <span class="approval-date" *ngIf="approvalDate$()">
              {{ 'header.viewAnswers.approvalDate' | translate }}: {{ approvalDate$() | date:'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="task-number" *ngIf="recipientId$()">
            {{ 'header.viewAnswers.formNumber' | translate }}:
            {{ recipientId$() }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="left">
    <div class="wrap-buttons" *ngIf="status$() == enum.PendingApproval">
      <div class="buttons reject" (click)="respond(enum.Rejected)">
        <svg-icon svgClass="img" class="icon" src="/assets/images/close.svg"></svg-icon>
        <p class="text" translate>header.viewAnswers.reject</p>
      </div>
      <div class="buttons approve" (click)="respond(enum.Approved)">
        <svg-icon class="icon" src="/assets/images/check.svg"></svg-icon>
        <p class="text" translate>header.viewAnswers.approve</p>
      </div>
    </div>
    <div *ngIf="status$() != enum.PendingApproval">
      <que-questionnaire-status [statusApproval]="status$()"></que-questionnaire-status>
    </div>
  </div>
</div>